/* @ngInject */
export default function ($scope, AuthService, LayoutService) {
	LayoutService.setTitle('Dashboard');
	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'supportWorker.dashboard',
			             displayName: 'Dashboard',
		             },
	             ]);

	$scope.user = AuthService.getUser();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/supportWorker/dashboard/controller.js